const homeEventsEN = {
    movieTime: {
        header: "<1>Movie Time</1>",
        body: "You entered the bedroom and saw that <1>wife</1> had turned on the TV and was choosing a movie." +
            "<2/>" +
            "<3>Are we watching a movie?</3> You asked. <1>wife</1> gave you an indifferent look." +
            "<4>No, just me. But if you want, you can sit on the other end and watch too.</4>" +
            "<3>Hmm, okay...</3> You sat on the other side of the room and that's how you started watching the movie.\n" +
            "<5>Improve relationships with {{wife}} to see more scenes.</5><6/><6/>" +
            "<7>Finish watching</7>"
    },

    movieTimeWatchTogether: "<1>Movie Time</1>" +
        "You entered the room and <2>wife</2> immediately approached you." +
        "<3>I'm bored, can we watch something?</3>" +
        "<4>Okay, why not.</4>You said as you approached the TV." +
        "<5/>" +
        "You have chosen a movie and started watching.\n" +
        "After a while, you noticed that <2>wife</2> began to constantly spin and press her arms to her chest." +
        "<4>What is up? Are you okay?</4>You asked. <2>wife</2> pulled away from you and ran her hands over her chest." +
        "<6/>" +
        "<3>Feeling like my chest hurts. Maybe her period is coming soon?</3> You watched her run her hand over her boobs and got aroused.\n\n" +
        "<7>Let me see (not available in this version)</7><8/>" +
        "<9>Maybe you're just uncomfortable?</9>",

    movieTimeUncomfortable: "<1>Movie Time</1>" +
        "<2>Probably you are just sitting uncomfortably, lie down on my knees.</2> You offered her." +
        "<3>Ok, let's try...</3>" +
        "<4/>" +
        "In this position, you continued to watch the movie. After a while, <5>wife</5> told you:" +
        "<3>Yes, you were right, the chest no longer hurts.</3><6/><6/>" +
        "<7>Finish watching</7>",

    bedTime: {
        header: "<1>Nap Time</1>",
        body: "You entered the room and saw <1>wife</1> lying on the bed." +
            "<2/>" +
            "<3>Something happened? Why are you lying?</3>" +
            "<4>What, I can’t just lie down already?</4><5>nick</5> asked irritably." +
            "<3>You can, of course... Can I join?</3>" +
            "<4>You can, but don't touch me...</4>" +
            "You lay next to your wife on the bed, continuing to look at her. She turned away.\n" +
            "So you lay there for a while.\n" +
            "<6>Improve relationships with {{wife}} to see more scenes.</6><7/><7/>" +
            "<8>Get up</8>"
    },

    bedTimeTogether: "<1>Nap Time</1>" +
        "You entered the room and saw <2>wife</2> lying on the bed." +
        "<3>I feel like I want to lie down, will you join me?</3>She asked you." +
        "<4>With my pleasure</4>You lay down next to her and you hugged." +
        "<5/>" +
        "You lay there for a while, but then <2>wife</2>'s phone rang, which was lying somewhere under the bed. " +
        "She freed herself from your embrace and reached out to it. You got a great view of your wife's ass." +
        "<6/>" +
        "You turned on from the view." +
        "<3>Quiet, mom is calling.</3>Without changing her position, she said.\n\n" +
        "<7>Slap her on the ass (not available in this version)</7><8/>" +
        "<9>Don't bother her</9>",

    bedTimeTogetherLetHerSpeak: "<1>Nap Time</1>" +
        "You decided not to interfere with her conversation with her mother. After some time, they done talking and she returned to your arms." +
        "<2/><3/>" +
        "<4>Get up</4>",

    walkTime: {
        header: "<1>Walking time</1>",
        body: "You entered the room and saw that <1>wife</1> was going somewhere." +
            "<2/>" +
            "<3>Where are you going?</3>" +
            "<4>Away from here... Okay, I'm going for a walk...</4> Reluctantly, <1>wife</1> answered." +
            "<3>Then I'm going with you.</3>" +
            "<4>Okay, let's just not talk too much, I'm tired...</4>" +
            "<3>Okay...</3>" +
            "After a while, you went for a walk in a nearby park." +
            "<5/>" +
            "Every time you tried to hold <1>wife</1> by the hand or talk to her, she wouldn't let you.\n" +
            "After a while it started to get dark.\n" +
            "<6>Improve relationships with {{wife}} to see more scenes.</6><7/><7/>" +
            "<8>Go home</8>"
    },

    walkTimeTogether: "<1>Walking time</1>" +
        "You entered the room and saw that <2>wife</2> was going somewhere." +
        "<3/>" +
        "<4>I want to go for a walk, shall we?</4>" +
        "<5>Yes, let's go.</5>" +
        "After a while, you left apartments and went to the nearest park." +
        "<6/>" +
        "You walked all the time, holding the handle and constantly chatting about something.\nSo an hour and a half passed.\n" +
        "At one point, you went to one of the places in the park, where a lot of people constantly pass, as it is located at the intersection of paths.\n" +
        "So this time you were overtaken by a girl with a gorgeous ass." +
        "<7/>" +
        "You tried your best not to look at her ass, but it didn't work for you, and you started staring at her." +
        "<4>{{player}}, where are you looking? Are you freaking kidding me?</4> <8>nick</8> tore her hand from yours." +
        "<5>Yeah, no... {{wife}}, you don't understand... I was just thinking...</5>" +
        "<4>Thinking about her butt? Go to hell, {{player}}.</4>" +
        "The girl overheard your conversation, turned and smiled at you.\n" +
        "You went on without speaking.\n" +
        "<9>End of event in this version.</9><10/><10/>" +
        "<11>Go home</11>",

    cookingTime: {
        header: "<1>Cooking Time</1>",
        body: "You entered the room and saw <1>wife</1> sitting at the computer. You decided not to disturb her and turn on the TV.\n" +
            "Minutes later she got up again, turned off the computer and left the room to the kitchen, you decided to follow her." +
            "<2>What are you going to do?</2>You asked as you entered the kitchen. <1>wife</1> was looking for something in the kitchen drawer." +
            "<3>Cooking, what else can I do in the kitchen?</3><1>wife</1> quipped as she pulled out a pot." +
            "<2>Can I help?</2>You asked." +
            "<3>No, thank you, I can handle it myself.</3>At that moment, her phone rang." +
            "<4/>" +
            "She answered the call and continued cooking. " +
            "The rest of the time she was on the phone, moving food and dishes around the kitchen table, as if not noticing you.\n" +
            "<5>Improve relationships with {{wife}} to see more scenes.</5><6/><6/>" +
            "<7>Move away</7>"
    },

    cookingTimeTogether: "<1>Cooking Time</1>" +
        "You entered the room and saw <2>wife</2> sitting at the computer. You decided not to disturb her and turn on the TV.\n" +
        "Minutes later she got up again, turned off the computer and said to you:" +
        "<3>{{player}}, I'm going to cook, can you help me?</3>" +
        "<4>With pleasure.</4>" +
        "You went to the kitchen and started cooking." +
        "<5/>" +
        "All the time you were laughing and chatting, because of which the process slowed down a bit.\n" +
        "After a while, several boiling pots made the kitchen very stuffy." +
        "<4>We should open the window, otherwise it is insanely stuffy...</4>" +
        "<3>Don't, I can catch a cold, you know... Better take off your sweater, and I'll go put on my shorts.</3>" +
        "She left and returned after a while. " +
        "She was wearing shorts, which she almost never wore, as they were too small and not suitable for everyday life, according to <2>wife</2>." +
        "<6/>" +
        "<4>Oh, those shorts...</4> You said with a smile." +
        "<3>Yes, yes, those shorts. Just please don’t touch me, we need to concentrate on cooking, otherwise we spent a lot of time ...</3>" +
        "<7>nick</7> said with a smile. She seemed to be reading your mind." +
        "<4>Yeah, I didn't even think...</4> You said looking at her ass, which looked perfect in those shorts.\n" +
        "You continue to cook...\n" +
        "<8>End of event in this version.</8><9/><9/>" +
        "<10>Finish cooking</10>",

    dressingTime: {
        header: "<1>Dressing Time</1>",
        body: "You entered the room at the perfect moment: <1>wife</1> was changing." +
            "<2/>" +
            "She heard your steps already from afar, so she turned away and said to you:" +
            "<3>{{player}}, go away, can't you see I'm changing?</3>" +
            "<4>Okay, sorry.</4><5/>" +
            "<6>Improve relationships with {{wife}} to see more scenes.</6><5/><5/>" +
            "<7>Escape</7>"
    },

    dressingTimeWatch: "<1>Dressing Time</1>" +
        "You entered the room at the perfect moment: <2>wife</2> was changing.\n" +
        "Apparently, she didn't hear you approach, because when you entered the room, she continued to change." +
        "<3/>" +
        "You watched your wife for a while and got hard.\n Thinking for a long time whether to approach her or not, you decided not to do it.\n" +
        "<4>End of event in this version.</4><5/><5/>" +
        "<6>Escape</6>"

};

export default homeEventsEN;